var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HistoryOrderInfo.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4fadb450\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HistoryOrderInfo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/History/HistoryOrderInfo.vue
// module id = 2157
// module chunks = 1